import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import * as UserActions from '../../../actions/UserActions'
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import { loginWithToken, _check_if_hiragana_only } from '../../../utils/Helper'
import Alert from 'react-s-alert';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import { API_URL } from '../../../utils/Settings'
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Input,
  Button,
} from 'reactstrap';
import shortid from 'shortid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import EvalScoreUpdatePart from './EvalScoreUpdatePart'
import AudioController from './AudioController'

let chunkWerList = []

// NaranciaView
const NaranciaView = (props) => {

  // use history
  let navigate = useNavigate()

  // user_state
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });

  let user_info = useSelector(state => {
    if (state.user && state.user.user_info) {
      return state.user.user_info
    } else {
      return ''
    }
  });

  let user_state_createdAt = useSelector(state => {
    if (state.user && state.user.createdAt) {
      return state.user.createdAt
    } else {
      return ''
    }
  });

  let dispatch = useDispatch();

  let playerRef = useRef(null)

  // parameters
  let [loading, setLoading] = useState(false);
  let [chunkItem, setChunkItem] = useState(null);
  let [audioUrl, setAudioUrl] = useState(null)
  let [audioDuration, setAudioDuration] = useState(0)
  let [seikaiTexts, setSeikaiTexts] = useState('')
  let [seikaiProcessed, setSeikaiProcessed] = useState('')
  // let [pageType, setPageType] = useState('score_update')

  // show engine adding div
  let [showEngineAddFlg, setShowEngineAddFlg] = useState(false)
  let [selectedEngineType, setSelectedEngineType] = useState("")
  let [engineList, setEngineList] = useState([])
  let [predictionTextsList, setPredictionTextsList] = useState([])
  let [chunkStatus, setChunkStatus] = useState("created")

  let [accountType, setAccountType] = useState('')
  let [masterId, setMasterId] = useState('')


  let [isPlaying, setIsPlaying] = useState(false)
  let [playerCurrentTime, setPlayerCurrentTime] = useState(0)

  let [chunkId, setChunkId] = useState(null)
  let [chunkList, setChunkList] = useState([])
  let [kanakanjiList, setKanakanjiList] = useState(null)

  // componentDidMount
  useEffect(() => {

    if (user_info && user_info.profile && user_info.profile.account_type) {
      setAccountType(user_info.profile.account_type)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_info]);

  // componentDidMount
  useEffect(() => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return;
    }

    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // first script
  let _firstScript = () => {

    // get params
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    let chunk_id = params.chunk_id
    setChunkId(chunk_id)
  }

  // componentDidMount
  useEffect(() => {

  if (!chunkId) {
    return
  }

  // reset
  setEngineList([])
  setSeikaiProcessed('')
  setKanakanjiList(null)

  console.log("erewar")
  _getEvaluationChunk(login_token, chunkId)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chunkId]);



  // get evaluation chunk
  let _getEvaluationChunk = async (_login_token, chunk_id) => {

    setAudioUrl(null)

    setLoading(true)

    try {

      // get voice to check
      const results_1 = await MyAPI.getNaranciaChunkOne({
        login_token: _login_token,
        chunk_id: chunk_id,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }
      console.log("getNaranciaChunkOne.results_1: ", results_1)

      if (results_1.chunk_item) {

        // text_list
        let processed_text_list = []

        let _chunkItem = results_1.chunk_item
        setChunkItem(_chunkItem)

        // chunkItem
        let audio_path = _chunkItem.audio_path

        let _base_url = API_URL+'/api/audio'
        let _audio_url = _base_url+"?audio_path="+audio_path

        setAudioUrl(_audio_url)

        // seikai
        if (_chunkItem.seikai) {
          setSeikaiTexts(_chunkItem.seikai)
          console.log("setSeikaiTexts ok")
        }

        if (results_1.inference_list) {

          console.log("results_1.inference_list: ", results_1.inference_list)

          // filter by engine_type
          let _inference_list = []
          for (let i=0; i<results_1.inference_list.length; i++) {
            // if (results_1.inference_list[i].engine_type === "amazon") {
            if (results_1.inference_list[i].engine_type === "google") {
            // if (results_1.inference_list[i].engine_type === "amivoice") {
            // if (results_1.inference_list[i].engine_type === "shabelab") {
              _inference_list.push(results_1.inference_list[i])

              // console.log(results_1.inference_list[i].transcript)
            } else if (results_1.inference_list[i].engine_type === "shabelab") {
              _inference_list.push(results_1.inference_list[i])
            }

            processed_text_list.push(results_1.inference_list[i].processed_texts)
          }

          // only for one
          setEngineList(_inference_list)

          // // for all
          // setEngineList(results_1.inference_list)

          console.log("setEngineList ok")
        }

        // seikai processed
        if (_chunkItem.seikai_processed) {
          setSeikaiProcessed(_chunkItem.seikai_processed)
          console.log("setSeikaiProcessed ok")

          processed_text_list.push(_chunkItem.seikai_processed)
        }

        if (results_1.chunk_list) {
          setChunkList(results_1.chunk_list)
        }

        // get kana kanji list
        console.log("_getNaranciaKanaKanjiPairFromWords 0")
        await _getNaranciaKanaKanjiPairFromWords(_login_token, processed_text_list)

      }

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    setLoading(false)
  }






  // get kana kanji list
  let _getNaranciaKanaKanjiPairFromWords = async (_login_token, processed_text_list) => {

    // console.log("_getNaranciaKanaKanjiPairFromWords. 1 ", processed_text_list)

    setLoading(true)

    try {

      let candidate_words = []

      // extract kanji
      for (let i=0; i<processed_text_list.length; i++) {

        let _processed_str = processed_text_list[i]
        let _processed_arr = _processed_str.split(" ")
        for ( let j=0; j<_processed_arr.length; j++ ) {

          let _word = _processed_arr[j]
          if (_word === "、") {
            continue
          } else if (_word === "。") {
            continue
          }

          if (_check_if_hiragana_only(_word) === false) {

            if (isNaN(_word) === true) {
              if (candidate_words.indexOf(_word) === -1) {
                candidate_words.push(_word)
              }
            }
          }
        }
      }

      // console.log("candidate_words: ", candidate_words)

      // get voice to check
      const results_1 = await MyAPI.getNaranciaKanaKanjiPairFromWords({
        login_token: _login_token,
        candidate_words_str: JSON.stringify(candidate_words),
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }
      console.log("getNaranciaKanaKanjiList.results_1: ", results_1)

      if (results_1.list1) {
        setKanakanjiList(results_1.list1)
      } else {
        setKanakanjiList([])
      }

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    setLoading(false)
  }



  let _pauseMedia2 = () => {
    setIsPlaying(false)
  }

  let _playMedia2 = () => {

    setIsPlaying(true)
  }

  let _reload = (arg0) => {
    console.log("arg0: ", arg0)
    setChunkId(arg0)
  }

  // _saveChunkWer
  let _saveChunkWer = ({
    engine_nickname,
    wer,
    count,
  }) => {

    let exists = false
    for ( let i=0; i<chunkWerList.length; i++ ) {
      if (chunkWerList[i].engine_nickname === engine_nickname && chunkWerList[i].chunk_id === chunkId) {
        // already exists
        exists = true
      }
    }

    if (exists === false) {
      chunkWerList.push({
        engine_nickname: engine_nickname,
        wer: wer,
        count: count,
        chunk_id : chunkId,
      })
    }
    // console.log("chunkWerList: ", chunkWerList)
  }

  let _keisan = () => {

    let _obj = {}

    for (let i=0; i<chunkWerList.length; i++) {
      let item = chunkWerList[i]
      let engine_nickname = item.engine_nickname
      let wer = item.wer
      let count = item.count
      console.log(i, ", item: ", item)

      if (!_obj[engine_nickname]) {
        _obj[engine_nickname] = {
          'count': 0,
          'wer': 0,
        }
      }
      _obj[engine_nickname].count = _obj[engine_nickname].count + count
      _obj[engine_nickname].wer = _obj[engine_nickname].wer + wer*count
    }

    // console.log("_obj: ", _obj)

    for ( let key in _obj ) {
      let item = _obj[key]
      let count = item.count
      let wer = item.wer

      console.log("key: ", key, ", ", parseFloat(100*wer/count).toFixed(2), count)
    }

  }

  return (
    <div style={{
      backgroundColor: '#F2F5FA',
    }}>

      {/* header */}
      <Header />

      <Row style={{
        // backgroundColor: '#cccccc',
        marginTop: 10,
        marginBottom: 10,
      }}>

        <Col md="2" xs="12" />
        <Col md="8" xs="12" style={{
          textAlign: 'left',
          backgroundColor: '#ffffff',
          padding: 20,
        }}>
          <span>
            {chunkId}
          </span>
          <span onClick={_keisan} style={{
            cursor: 'pointer',
            backgroundColor: 'red',
            color: 'white',
          }}>
            keisan
          </span>
        </Col>
        <Col md="2" xs="12" />

      </Row>

      <Row style={{
        // backgroundColor: '#cccccc',
        marginTop: 10,
        marginBottom: 10,
      }}>

        <Col md="2" xs="12" />
        <Col md="8" xs="12" style={{
          textAlign: 'left',
          backgroundColor: '#ffffff',
          padding: 20,
        }}>

          {chunkList.map((item, idx) => (

            <span key={item._id}
              onClick={() => _reload(item._id)} style={{
              cursor: 'pointer',
              color: item._id === chunkId ? '#000000' : '#ffffff',
              textDecoration: 'none',
            }}>

              <span style={{
                marginRight: 2,
                marginLeft: 2,
                backgroundColor: '#cccccc',
                padding: 4,
                fontSize: 8,
              }}>{idx}</span>

            </span>
          ))}

        </Col>
        <Col md="2" xs="12" />
      </Row>


      <Row style={{
        // backgroundColor: '#cccccc',
        marginTop: 10,
        marginBottom: 10,
      }}>

        <Col md="2" xs="12" style={{
          textAlign: 'right',
        }}>
          正解
        </Col>
        <Col md="8" xs="12" style={{
          textAlign: 'left',
          backgroundColor: '#ffffff',
          padding: 20,
        }}>
          {seikaiTexts}
        </Col>
        <Col md="2" xs="12" />
      </Row>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>

        <Col md="12" xs="12" style={{
          textAlign: 'center',
        }}>

          {audioUrl && (
            <div style={{
              position: 'relative',
              width: '100%',
            }}>
              <AudioController
                pauseMedia={_pauseMedia2}
                playMedia={_playMedia2}
                setPlayerCurrentTime={setPlayerCurrentTime}
                setIsPlaying={setIsPlaying}
                ref={playerRef}
                mediaUrl={audioUrl} />
            </div>
          )}

        </Col>
      </Row>

      <Container>

        {/* scoring... */}
        {seikaiProcessed && engineList.length > 0 && kanakanjiList && (
          <EvalScoreUpdatePart
            saveChunkWer={_saveChunkWer}
            accountType={"admin"}
            engineList={engineList}
            kanakanjiList={kanakanjiList}
            seikaiProcessed={seikaiProcessed} />
        ) }


      </Container>

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default NaranciaView
